import { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import OsBrandOrderConfirmationPage from "@faire/prototype-playground/workspace/lk/os-brand-order-confirmation";

const GongOsAnalysisPage = lazy(
  () => import("../../workspace/lk/gong-os-analysis")
);
const OpeningSoonH2StrategyPage = lazy(
  () => import("../../workspace/lk/opening-soon-h2-strategy")
);

export function LeonKempersRoutes() {
  return (
    <Switch>
      <Route path="/lk/gong-os-analysis" component={GongOsAnalysisPage} />
      <Route
        path="/lk/opening-soon-h2-strategy"
        component={OpeningSoonH2StrategyPage}
      />
      <Route path="/lk/os-brand-order-confirmation" component={OsBrandOrderConfirmationPage} />
    </Switch>
  );
}

export const slug = "lk";
